import { render } from "./PurposeDetails.vue?vue&type=template&id=2804dfdb&ts=true"
import script from "./PurposeDetails.vue?vue&type=script&lang=ts"
export * from "./PurposeDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__